// extracted by mini-css-extract-plugin
export var richText = "PricingTable-module--richText--5eb26";
export var section = "PricingTable-module--section--28bee";
export var tableWrapper = "PricingTable-module--tableWrapper--c321f";
export var wrapper = "PricingTable-module--wrapper--51027";